import { render, staticRenderFns } from "./AccordionProduct.vue?vue&type=template&id=641eba5f&scoped=true&"
import script from "./AccordionProduct.vue?vue&type=script&lang=js&"
export * from "./AccordionProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641eba5f",
  null
  
)

export default component.exports